// src/scripts/accessibility.js
import { createIcons, icons as lucideIcons } from 'lucide';

document.addEventListener('DOMContentLoaded', () => {
    const LS_FONT_STEP = 'a11y_font_step';
    const LS_THEME     = 'theme_mode';
    const LEGACY_LS_CONTRAST = 'a11y_contrast_enabled';
    const FONT_STEPS   = ['100%', '120%', '140%'];

    const ROOT = document.documentElement;
    const btnFonts  = document.querySelectorAll('.a11y-font');
    const btnThemes = document.querySelectorAll('.a11y-contrast');
    const live      = document.getElementById('a11y-live');

    if (!btnFonts.length || !btnThemes.length) return;

    const ICON_MOON = 'Moon';
    const ICON_SUN  = 'Sun';

    ensureRootFontStyle();

    // migrate legacy → new key
    if (localStorage.getItem(LEGACY_LS_CONTRAST) != null &&
        localStorage.getItem(LS_THEME) == null) {

        const legacy = localStorage.getItem(LEGACY_LS_CONTRAST) === '1';
        localStorage.setItem(LS_THEME, legacy ? 'dark' : 'light');
    }

    function getSystemTheme() {
        return window.matchMedia('(prefers-color-scheme: dark)').matches
            ? 'dark'
            : 'light';
    }


    // theme initial
    let themeMode = (localStorage.getItem(LS_THEME) || '').toLowerCase();

    if (!['light', 'dark'].includes(themeMode)) {
        themeMode = getSystemTheme();
        localStorage.setItem(LS_THEME, themeMode);
    }


    // font initial
    let fontStep = clampInt(localStorage.getItem(LS_FONT_STEP), 0, 2, 0);

    // apply initial states
    applyFont(fontStep, false);
    applyTheme(themeMode, false);

    // EVENTS
    btnFonts.forEach(btn => {
        btn.addEventListener('click', () => {
            fontStep = (fontStep + 1) % FONT_STEPS.length;
            applyFont(fontStep, true);
        });
    });

    btnThemes.forEach(btn => {
        btn.addEventListener('click', () => {
            const next = ROOT.classList.contains('dark') ? 'light' : 'dark';
            applyTheme(next, true);
        });
    });

    /* --- IMPLEMENTATION --- */

    function applyFont(step, announce) {
        const size = FONT_STEPS[step];

        ROOT.style.setProperty('--a11y-font-size', size);
        ROOT.style.fontSize = size;
        void ROOT.offsetHeight;

        localStorage.setItem(LS_FONT_STEP, step);

        btnFonts.forEach(btn => {
            btn.setAttribute('aria-pressed', step > 0 ? 'true' : 'false');

            const next = (step + 1) % FONT_STEPS.length;
            const nextSize = FONT_STEPS[next];
            btn.setAttribute(
                'aria-label',
                next === 0 ? 'Przywróć domyślny rozmiar tekstu' : `Powiększ tekst do ${nextSize}`
            );
        });

        if (announce) say(`Rozmiar tekstu ${size}`);
    }

    function applyTheme(mode, announce) {
        const isDark = mode === 'dark';

        ROOT.classList.toggle('dark', isDark);
        localStorage.setItem(LS_THEME, mode);

        btnThemes.forEach(btn => {
            btn.setAttribute('aria-pressed', isDark ? 'true' : 'false');
            btn.setAttribute('aria-label', isDark ? 'Wyłącz tryb ciemny' : 'Włącz tryb ciemny');

            const iconSpan = btn.querySelector('.js-icon');
            setIcon(iconSpan, isDark ? ICON_SUN : ICON_MOON, btn);
        });

        if (announce) say(isDark ? 'Włączono tryb ciemny' : 'Włączono tryb jasny');
    }

    /* --- Utils --- */

    function setIcon(targetSpan, iconName, container) {
        if (!targetSpan) return;

        if (!lucideIcons || !lucideIcons[iconName]) {
            targetSpan.textContent = iconName === ICON_MOON ? '🌙' : '☀️';
            return;
        }

        targetSpan.innerHTML = `<i data-lucide="${iconName}"></i>`;
        createIcons({ icons: lucideIcons }, container || targetSpan);
    }

    function say(msg) {
        if (!live) return;
        live.textContent = '';
        setTimeout(() => { live.textContent = msg; }, 10);
    }

    function clampInt(val, min, max, def) {
        const n = parseInt(val ?? '', 10);
        return Number.isNaN(n) ? def : Math.max(min, Math.min(max, n));
    }

    function ensureRootFontStyle() {
        if (document.getElementById('a11y-root-font')) return;
        const s = document.createElement('style');
        s.id = 'a11y-root-font';
        s.textContent = `
            html {
                font-size: var(--a11y-font-size,100%) !important;
                transition: font-size .2s ease;
            }
            @media (prefers-reduced-motion: reduce) {
                html { transition: none; }
            }
        `;
        document.head.appendChild(s);
    }
});
